module.exports = __webpack_public_path__ + "assets/img/image-1.a6d5d07d.png";